module.exports = __webpack_public_path__ + "static/Majesti-Bold-e72d3a93c687de35cfaa58870cafd70f.otf";